import React, { FC } from 'react';
import clsx from 'clsx';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
// components
import { Card as MCard, CardContent, CardHeader, Collapse, SxProps } from '@mui/material/';

interface ICard {
  title: string | React.ReactNode;
  icon?: JSX.Element;
  children: any;
  action?: JSX.Element;
  isExpanded?: boolean;
  cardTitleClassName?: string;
  headerClassName?: string;
  cardWrapperClassName?: string;
  cardContentRootClassName?: string;
  cardHeaderActionClassName?: string;
  cardHeaderSx?: SxProps<Theme>;
}

export const Card: FC<ICard> = ({
  title,
  icon,
  children,
  action,
  isExpanded = true,
  cardTitleClassName,
  headerClassName,
  cardWrapperClassName,
  cardContentRootClassName,
  cardHeaderActionClassName,
  cardHeaderSx
}) => {
  const classes = useStyles();

  return (
    <MCard
      elevation={0}
      variant="outlined"
      className={clsx(classes.marginBottom, cardWrapperClassName)}
    >
      <CardHeader
        classes={{
          avatar: classes.avatar,
          action: clsx(classes.cardHeaderAction, cardHeaderActionClassName),
          title: clsx(classes.cardTitle, cardTitleClassName)
        }}
        avatar={icon}
        title={title}
        className={clsx(classes.primaryHeader, headerClassName)}
        sx={cardHeaderSx}
        action={action}
      />
      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <CardContent classes={{ root: cardContentRootClassName }} className={classes.cardContent}>
          {children}
        </CardContent>
      </Collapse>
    </MCard>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    paddingTop: theme.spacing(0.125),
    position: 'relative'
  },
  primaryHeader: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white
  },
  cardTitle: {
    textTransform: 'uppercase',
    fontSize: '0.85rem'
  },
  cardContent: {
    paddingTop: 0,
    marginTop: theme.spacing(1)
  },
  marginBottom: {
    marginBottom: theme.spacing(1)
  },
  avatar: {},
  cardHeaderAction: {
    alignSelf: 'inherit'
  }
}));
